type StartupMark = {
  step: string;
  at: number;
  extra?: Record<string, unknown>;
};

type RuntimeFlags = {
  inAppSafeMode?: boolean;
  isInstagramInApp?: boolean;
  isFacebookInApp?: boolean;
  isIOS?: boolean;
  webkitShimApplied?: boolean;
};

type RuntimeWindow = Window & {
  __tarotStartupMarks?: StartupMark[];
  __tarotRuntimeFlags?: RuntimeFlags;
};

const MAX_MARKS = 40;

export function addStartupMark(
  step: string,
  extra?: Record<string, unknown>
): void {
  if (typeof window === "undefined") return;
  try {
    const w = window as RuntimeWindow;
    const current = w.__tarotStartupMarks || [];
    const next: StartupMark = {
      step,
      at: Date.now(),
      extra,
    };
    const merged = [...current, next].slice(-MAX_MARKS);
    w.__tarotStartupMarks = merged;
  } catch {
    // Keep diagnostics best-effort.
  }
}

export function getStartupMarks(): StartupMark[] {
  if (typeof window === "undefined") return [];
  try {
    const w = window as RuntimeWindow;
    return w.__tarotStartupMarks ? [...w.__tarotStartupMarks] : [];
  } catch {
    return [];
  }
}

export function getRuntimeFlags(): RuntimeFlags | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    const w = window as RuntimeWindow;
    return w.__tarotRuntimeFlags ? { ...w.__tarotRuntimeFlags } : undefined;
  } catch {
    return undefined;
  }
}

export function isRuntimeSafeModeEnabled(): boolean {
  return getRuntimeFlags()?.inAppSafeMode === true;
}
